import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LangObservablePipe } from '../pipes/lang-obervable.pipe';

@NgModule({
	declarations: [LangObservablePipe],
	exports: [LangObservablePipe],
	imports: [CommonModule],
	providers: [],
})
export class SharedUiModule {}
